import { render, staticRenderFns } from "./InquiryList.vue?vue&type=template&id=71a914ff&scoped=true&"
import script from "./InquiryList.vue?vue&type=script&lang=js&"
export * from "./InquiryList.vue?vue&type=script&lang=js&"
import style0 from "./InquiryList.vue?vue&type=style&index=0&id=71a914ff&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a914ff",
  null
  
)

export default component.exports